import { render, staticRenderFns } from "./functionalities.page.vue?vue&type=template&id=1ba8a778"
import script from "./functionalities.page.vue?vue&type=script&lang=ts"
export * from "./functionalities.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports